<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="TraderecordRespVo" ref="queryForm" label-width="auto" size="small" inline>


        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('mainPage.gwNo')" prop="gwNo">
            <div class="input-with-more">
              <el-input v-model="TraderecordRespVo.gwNo" :placeholder="$t('mainPage.gwNo')" clearable />
              <!--              <el-button type="text" @click="openMoreDialog('orderNo')">More</el-button>-->
            </div>
          </el-form-item>
        </el-col>


        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('mainPage.country')" prop="country">
            <div class="input-with-more">
              <el-input v-model="TraderecordRespVo.country" :placeholder="$t('mainPage.country')" clearable />
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('mainPage.billname')" prop="billname">
            <div class="input-with-more">
              <el-input v-model="TraderecordRespVo.billname" :placeholder="$t('mainPage.billname')" clearable />
            </div>
          </el-form-item>
        </el-col>

        <el-form-item :label="$t('date')" prop="dateRange">

          <el-date-picker

              v-model="TraderecordRespVo.dateRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"

              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
              :default-time="['00:00:00','23:59:59']"
              :picker-options="pickerOptions"
          />

        </el-form-item>



        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>

        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
          :visible.sync="moreDialogVisible"
          width="800px"
          @close="onMoreDialogClose"
        >
          <el-input
            type="textarea"
            :rows="8"
            v-model="moreInput"
            :placeholder="`请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：\nVALUE1\nVALUE2, VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>
      </el-form>
    </el-card>

    <div class="action-toolbar">

<!--      <el-button
        :disabled="!hasSearched"
        :loading="summaryLoading"
        @click="handleOpenSummary"
        type="success"
        plain
        icon="el-icon-data-analysis"
      >
        成功率概览
      </el-button>-->

      <el-button
        v-if="hasPermission('admin/showMerFormsTradeListInfo', 'downExcel')"
        :disabled="!hasSearched"
        :loading="downloadLoading"
        @click="handleDownload"
        type="primary"
        icon="el-icon-download"
      >
        {{ $t('button.download') }}
      </el-button>

    </div>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column prop="gwNo" sortable="custom" :label="$t('mainPage.gwNo')" :min-width="columnWidths.gwNo"></el-table-column>

        <el-table-column prop="country" :label="$t('mainPage.country')":min-width="columnWidths.country"></el-table-column>
        <el-table-column prop="billname" :label="$t('mainPage.billname')":min-width="columnWidths.billname"></el-table-column>
        <el-table-column prop="currency" :label="$t('mainPage.currency')":min-width="columnWidths.currency"></el-table-column>
        <el-table-column prop="amount" :label="$t('mainPage.amount')":min-width="columnWidths.amount"></el-table-column>
        <el-table-column prop="cnt" :label="$t('mainPage.cnt')":min-width="columnWidths.cnt"></el-table-column>
        <el-table-column prop="allUniqueEmails" :label="$t('mainPage.allUniqueEmails')":min-width="columnWidths.allUniqueEmails"></el-table-column>
        <el-table-column prop="succUniqueEmails" :label="$t('mainPage.succUniqueEmails')":min-width="columnWidths.succUniqueEmails"></el-table-column>
        <el-table-column prop="allUniqueCard" :label="$t('mainPage.allUniqueCard')":min-width="columnWidths.allUniqueCard"></el-table-column>
        <el-table-column prop="succUniqueCard" :label="$t('mainPage.succUniqueCard')":min-width="columnWidths.succUniqueCard"></el-table-column>
        <el-table-column prop="succAmount" :label="$t('mainPage.succAmount')":min-width="columnWidths.succAmount"></el-table-column>
        <el-table-column prop="succCnt" :label="$t('mainPage.succCnt')":min-width="columnWidths.succCnt"></el-table-column>
        <el-table-column prop="succRate" :label="$t('mainPage.succRate1')":min-width="columnWidths.succRate1"></el-table-column>
        <el-table-column prop="emailSuccessRate" :label="$t('mainPage.emailSuccessRate')":min-width="columnWidths.emailSuccessRate"></el-table-column>
        <el-table-column prop="cardSuccessRate" :label="$t('mainPage.cardSuccessRate')":min-width="columnWidths.cardSuccessRate"></el-table-column>
        <el-table-column prop="succAmountRate" :label="$t('mainPage.succAmountRate')":min-width="columnWidths.succAmountRate"></el-table-column>
        <el-table-column prop="failAmount" :label="$t('mainPage.failAmount')":min-width="columnWidths.failAmount"></el-table-column>
        <el-table-column prop="failCnt" :label="$t('mainPage.failCnt')":min-width="columnWidths.failCnt"></el-table-column>
        <el-table-column prop="unnAmount" :label="$t('mainPage.unnAmount')":min-width="columnWidths.unnAmount"></el-table-column>
        <el-table-column prop="unnCnt" :label="$t('mainPage.unnCnt')":min-width="columnWidths.unnCnt"></el-table-column>
        <el-table-column prop="unnRate" :label="$t('mainPage.unnRate')":min-width="columnWidths.unnRate"></el-table-column>






      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>

    <el-dialog
      title="📊 综合数据概览"
      :visible.sync="summaryDialogVisible"
      width="800px"
      custom-class="elegant-dialog"
      append-to-body
    >
      <div v-loading="summaryLoading">
        <el-descriptions class="margin-top" :column="3" border size="medium">

          <el-descriptions-item :label="$t('mainPage.cnt')">
            <span class="highlight-text">{{ summaryData.allCnt || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.succCnt')">
            <span class="highlight-text success-text">{{ summaryData.allSuccCnt || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.succRate1')">
            <span class="highlight-text success-text">{{ summaryData.allSuccRate || '0.00%' }}%</span>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('mainPage.allUniqueEmails')">
            <span class="highlight-text">{{ summaryData.allUniqueEmails || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.succUniqueEmails')">
            <span class="highlight-text success-text">{{ summaryData.succUniqueEmails || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.emailSuccessRate')">
            <span class="highlight-text success-text">{{ summaryData.emailSuccessRate ||'0.00%' }}</span>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('mainPage.allUniqueCard')">
            <span class="highlight-text">{{ summaryData.allUniqueCard || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.succUniqueCard')">
            <span class="highlight-text success-text">{{ summaryData.succUniqueCard || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('mainPage.cardSuccessRate')">
            <span class="highlight-text success-text">{{ summaryData.cardSuccessRate || '0.00%' }}</span>
          </el-descriptions-item>

        </el-descriptions>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="summaryDialogVisible = false" round>关 闭</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      pickFirstDate: null,

      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          // 记录第一次选择的日期
          this.pickFirstDate = minDate.getTime();
          // 如果已经选择了两个日期，重置
          if (maxDate) {
            this.pickFirstDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果已经选择了第一个日期，限制30天范围
          if (this.pickFirstDate) {
            const day = 30 * 24 * 3600 * 1000; // 30天
            const maxTime = this.pickFirstDate + day;
            const minTime = this.pickFirstDate - day;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
          return false;
        }
      },
      summaryDialogVisible: false,
      summaryLoading: false, // 控制概览弹窗内部的加载状态
      loading: false,
      // 弹窗数据
      summaryData: {
        allCnt:"",
        allSuccCnt:"",
        allSuccRate:"",
        allUniqueEmails:"",
        succUniqueEmails:"",
        allUniqueCard:"",
        succUniqueCard:"",
        emailSuccessRate:"",
        cardSuccessRate:"",
      },
      TraderecordRespVo: {
        dateRange:[],
        startDate: "",
        endDate: "",
        hkbatchNo: "",
        gwNo: "",
        country: "",
        billname: "",

        sortField: undefined,
        sortOrder: undefined
      },
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      downloadLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",


    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    //this.setDefaultTime(); //时间设置
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  computed:{
    pickerOptionsStart() {
      const endDate = this.TraderecordRespVo.endDate
      return {
        disabledDate: (time) => {
          if (!endDate) return false
          const end = new Date(endDate)
          const min = new Date(end)
          min.setMonth(min.getMonth() - 1) // 往前推一个月
          const minDay = new Date(min.getFullYear(), min.getMonth(), min.getDate()).getTime()
          const maxDay = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime()
          return time.getTime() < minDay || time.getTime() > maxDay
        }
      }
    },

    // 结束时间：不能早于开始时间，且不能晚于「开始时间 + 1个月」
    pickerOptionsEnd() {
      const startDate = this.TraderecordRespVo.startDate
      return {
        disabledDate: (time) => {
          if (!startDate) return false
          const start = new Date(startDate)
          const minDay = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime()
          const max = new Date(start)
          max.setMonth(max.getMonth() + 1) // 往后推一个月
          const maxDay = new Date(max.getFullYear(), max.getMonth(), max.getDate()).getTime()
          return time.getTime() < minDay || time.getTime() > maxDay
        }
      }
    }
  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.TraderecordRespVo.sortField = undefined;
        this.TraderecordRespVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.TraderecordRespVo.sortField = prop;
        this.TraderecordRespVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.TraderecordRespVo.startDate) {
        this.TraderecordRespVo.startDate = this.getDefaultStartTime();
      }
      if (!this.TraderecordRespVo.endDate) {
        this.TraderecordRespVo.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      /*    const now = new Date();
          const oneYearAgo = new Date(now);
          oneYearAgo.setFullYear(now.getFullYear() - 1);
          return this.formatDateTime(oneYearAgo);*/
      const now = new Date();

      // 1. 获取当前时间的毫秒时间戳
      const currentTimestamp = now.getTime();

      // 2. 计算2天的毫秒数 (2 * 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

      // 3. 用当前时间戳减去2天的毫秒数
      const twoDaysAgoTimestamp = currentTimestamp - twoDaysInMs;

      // 4. 基于新的时间戳创建日期对象
      const twoDaysAgo = new Date(twoDaysAgoTimestamp);

      // 5. 重置为当天 00:00:00 (注意：这里重置的是"2天前"那天的0点)
      twoDaysAgo.setHours(0, 0, 0, 0);

      return this.formatDateTime(twoDaysAgo);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        if (!this.TraderecordRespVo.dateRange || this.TraderecordRespVo.dateRange.length === 0) {
          this.$message.warning(this.$t('selectDateRange'));
          return;
        }
        if(this.TraderecordRespVo.dateRange){

          this.TraderecordRespVo.startDate =
              this.TraderecordRespVo.dateRange[0];


          this.TraderecordRespVo.endDate =
              this.TraderecordRespVo.dateRange[1];

        }
        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          hkbatchNo: this.TraderecordRespVo.hkbatchNo || undefined,
          gwNo: this.TraderecordRespVo.gwNo || undefined,
          country: this.TraderecordRespVo.country || undefined,
          billname: this.TraderecordRespVo.billname || undefined,

          sortField: this.TraderecordRespVo.sortField || undefined,
          sortOrder: this.TraderecordRespVo.sortOrder || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/traderecord/mer/forms/traderRecord/list',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 打开数据概览并请求接口
    async handleOpenSummary() {

      this.summaryDialogVisible = true;
      this.summaryLoading = true;

      try {
        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          hkbatchNo: this.TraderecordRespVo.hkbatchNo || undefined,
          gwNo: this.TraderecordRespVo.gwNo || undefined,
          country: this.TraderecordRespVo.country || undefined,
          billname: this.TraderecordRespVo.billname || undefined
        };

        const res = await this.$axios.post('/api/traderecord/mer/forms/traderRecord/summaryData/info', params);

        if (res.data.code === 0) {
          // 拿到数据后，赋值给变量。如果后端返回的字段名和你不一致，请在这里做映射，例如：
          // this.summaryData.totalCnt = res.data.data.total_count;
          this.summaryData = res.data.data || this.summaryData;
        } else {
          this.$message.error(res.data.msg || '获取统计数据失败');
        }
      } catch (err) {
        console.error('获取概览数据失败:', err);
        this.$message.error('网络错误，请稍后重试');
      } finally {
        // 请求结束，关闭 loading
        this.summaryLoading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 下载
    // 下载报表
    async handleDownload() {
      if (this.downloadLoading) return;
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));
      try {
        if (!this.TraderecordRespVo.dateRange || this.TraderecordRespVo.dateRange.length === 0) {
          this.$message.warning(this.$t('selectDateRange'));
          return;
        }
        if(this.TraderecordRespVo.dateRange){

          this.TraderecordRespVo.startDate =
              this.TraderecordRespVo.dateRange[0];


          this.TraderecordRespVo.endDate =
              this.TraderecordRespVo.dateRange[1];

        }
        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          hkbatchNo: this.TraderecordRespVo.hkbatchNo || undefined,
          gwNo: this.TraderecordRespVo.gwNo || undefined,
          country: this.TraderecordRespVo.country || undefined,
          billname: this.TraderecordRespVo.billname || undefined,
        };


        const res = await this.$axios.post('/api/traderecord/mer/forms/traderRecord/summaryData/info/downExcel', params, {
          responseType: 'blob'
        });

        //
        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }

        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        if (res.headers['x-export-truncated'] === 'true') {
          const original = res.headers['x-export-original-size'];
          const exported = res.headers['x-exported-size'];
          const warningText = this.$t('export_truncated_warning').replace('{exported}', exported).replace('{original}', original);
          this.$message.warning(warningText);
        }

        //从请求头 Content-Disposition 中获取文件名 (需要后端配合暴露该 Header，否则使用默认值)
        let fileName = `拒付交易查询_${new Date().getTime()}.xlsx`;
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes('attachment')) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            // 解决中文乱码问题
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
          }
        }

        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success(this.$t('export_success'));
      } catch (err) {
        console.error('获取概览数据失败:', err);
        this.$message.error(this.$t('requestFailed'));
      } finally {
        // 请求结束，关闭 loading
        this.downloadLoading = false;
      }
    },
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },
    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.TraderecordRespVo[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },


    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
        .split('#')
        .map(item => item.trim())  // 去掉每个值的前后空格
        .filter(item => item.length > 0)  // 过滤空值
        .join('#');  // 用 # 重新连接

      this.TraderecordRespVo[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

    // 表头宽度
    initColumnWidths() {
      const cols = [
        "gwNo",
        "country",
        "billname",
        "currency",
        "amount",
        "cnt",
        "allUniqueEmails",
        "succUniqueEmails",
        "allUniqueCard",
        "succUniqueCard",
        "succAmount",
        "succCnt",
        "succRate1",
        "emailSuccessRate",
        "cardSuccessRate",
        "succAmountRate",
        "failAmount",
        "failCnt",
        "unnAmount",
        "unnCnt",
        "unnRate"
      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `mainPage.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
/*隐藏此刻*/
.no-now-btn .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}


/* --- 数据概览弹窗美化 --- */
/* 调整弹窗圆角和头部背景 */
::v-deep .elegant-dialog {
  border-radius: 10px !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

::v-deep .elegant-dialog .el-dialog__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
  padding: 16px 20px;
}

::v-deep .elegant-dialog .el-dialog__title {
  font-weight: 600;
  color: #303133;
  font-size: 16px;
}

/* 描述列表单元格美化 */
::v-deep .elegant-dialog .el-descriptions-item__label {
  background-color: #fafafa !important;
  font-weight: bold;
  color: #606266;
  width: 120px; /* 固定标签宽度，保持对齐 */
  text-align: right;
}

::v-deep .elegant-dialog .el-descriptions-item__content {
  background-color: #ffffff !important;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

/* 强调文字的样式 */
.highlight-text {
  font-weight: 600;
  font-size: 15px;
  color: #303133;
}
.success-text {
  color: #303133;
}
.danger-text {
  color: #303133;
}

/* 关闭按钮稍微调整 */
.dialog-footer .el-button {
  padding: 10px 30px;
  font-weight: bold;
  letter-spacing: 1px;
}

</style>



// WEBPACK FOOTER //
// src/view/admin/mainPage.vue